// src/components/landing/HowItWorks.tsx
import React from "react";
import { Search, CheckCircle2, ShieldCheck } from "lucide-react";

const steps = [
  { icon: Search, title: "Search & compare", body: "Filter by state, city, media type and budget to shortlist verified spaces in minutes." },
  { icon: CheckCircle2, title: "Add to cart & review", body: "Build a shortlist across multiple spaces, review it on one page, then check out." },
  { icon: ShieldCheck, title: "Go live, verified", body: "We coordinate printing, mounting and proof-of-display so your campaign launches on time." },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="mx-auto max-w-7xl px-5 py-20 sm:px-8">
      <div className="max-w-lg">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-[#1D9BD8]">How it works</span>
        <h2 className="font-display mt-3 text-3xl text-[#0F172A] sm:text-4xl">From shortlist to street, in three steps.</h2>
      </div>
      <div className="mt-12 grid gap-6 sm:grid-cols-3">
        {steps.map((s, i) => (
          <div key={s.title} className="relative rounded-2xl border border-slate-200 bg-[#F8FAFD] p-6">
            <span className="font-display text-5xl text-slate-200">0{i + 1}</span>
            <div className="mt-2 flex h-10 w-10 items-center justify-center rounded-xl bg-white shadow-sm">
              <s.icon className="h-5 w-5 text-[#1D9BD8]" />
            </div>
            <h3 className="mt-4 text-base font-semibold text-[#0F172A]">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}